module.exports = __webpack_public_path__ + "static/media/icon-facebook.04af7203.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bonusView/icon-facebook.svg
// module id = 483
// module chunks = 0